import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: ${props => (props.direction ? props.direction : "column")};
`;

export default Container;
